import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { cloneElement, Component } from 'react';
import AbstractSwitch from '../../../abstract/AbstractSwitch';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
import { resolveValidation } from '../../../molecules/Validation';
import { validationDisplayTypePropType } from '../../../molecules/Validation/propTypes';
import CheckboxSvg from '../../SvgIcon/Icons/Checkbox';
import CheckboxCheckedSvg from '../../SvgIcon/Icons/CheckboxChecked';
const COMPONENT_NAME = 'Checkbox';
class Checkbox extends Component {
    handleChange = (e, isChecked)=>{
        this.props.onChange?.(e, isChecked);
    };
    handleKeyPressForAbstractSwitch = (e)=>{
        e.preventDefault();
        if (e.charCode === 32) {
            this.handleChange(e, !this.props.checked);
        }
    };
    render() {
        const { label, labelClassName, disabled, className, validationText, hideValidationText, validationClassName, checked, tabIndex, sizeSmall, validationDisplayType, tooltipComponent, uncheckedIcon, checkedIcon, disabledUncheckedIcon, disabledCheckedIcon, ...other } = this.props;
        const validationElement = resolveValidation({
            hideValidationText,
            validationText,
            validationClassName,
            validationDisplayType,
            tooltipComponent
        });
        const icon = checked ? disabled && disabledCheckedIcon || checkedIcon : disabled && disabledUncheckedIcon || uncheckedIcon;
        return /*#__PURE__*/ React.createElement("div", {
            onClick: (e)=>e.stopPropagation(),
            className: cx('Checkbox', {
                'Checkbox--checked': checked,
                'Checkbox--disabled': disabled,
                'Checkbox--sizeSmall': sizeSmall
            }, className)
        }, /*#__PURE__*/ React.createElement("label", {
            className: cx('Checkbox-label', labelClassName)
        }, /*#__PURE__*/ React.createElement("span", {
            tabIndex: disabled ? undefined : tabIndex,
            onKeyPress: this.handleKeyPressForAbstractSwitch,
            className: "Checkbox-box"
        }, /*#__PURE__*/ React.createElement(AbstractSwitch, {
            ref: (ref)=>{
                this.switch = ref;
            },
            className: cx('Checkbox-control'),
            inputType: "checkbox",
            switched: checked,
            onSwitch: this.handleChange,
            disabled: disabled,
            ...other
        }), /*#__PURE__*/ cloneElement(icon, {
            className: 'Checkbox-icon'
        })), /*#__PURE__*/ React.createElement("span", {
            className: "Checkbox-text"
        }, label)), validationElement);
    }
}
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
    /**
	 * If true, the checkbox field will be selected.
	 */ checked: PropTypes.bool,
    /**
	 * Checked state icon node
	 */ checkedIcon: PropTypes.node,
    /**
	 * Root className.
	 */ className: PropTypes.string,
    /**
	 * If true, the checkbox field will be check on render.
	 */ defaultChecked: PropTypes.bool,
    /**
	 * If true, the checkbox field will be disabled.
	 */ disabled: PropTypes.bool,
    /**
	 * Disabled checked state icon node
	 */ disabledCheckedIcon: PropTypes.node,
    /**
	 * Disabled unchecked state icon node
	 */ disabledUncheckedIcon: PropTypes.node,
    /**
	 * Whether to render validation component.
	 */ hideValidationText: PropTypes.bool,
    /**
	 * Text displayed next to checkbox.
	 */ label: PropTypes.node,
    /**
	 * ClassName applied to `label` element.
	 */ labelClassName: PropTypes.string,
    /**
	 * Name of the input field.
	 */ name: PropTypes.string,
    /**
	 * Callback function fired when checkbox is checked.
	 *
	 * @param {object} event event targeting the element.
	 * @return {undefined} Nothin'
	 */ onChange: PropTypes.func,
    /**
	 * If true, Checkbox will be rendered with sizeSmall modifier
	 */ sizeSmall: PropTypes.bool,
    /**
	 * tabindex html property of wrapping element
	 */ tabIndex: PropTypes.number,
    /**
	 * component for tooltip validation
	 */ tooltipComponent: PropTypes.any,
    /**
	 * Unchecked state icon node
	 */ uncheckedIcon: PropTypes.node,
    /**
	 * Set class for validation component.
	 */ validationClassName: PropTypes.string,
    /**
	 * Where to display validation
	 */ validationDisplayType: validationDisplayTypePropType,
    /**
	 * Text that will be shown when withValidity decorator decides to show validation text.
	 */ validationText: PropTypes.node,
    /**
	 * Value of the input field.
	 */ value: PropTypes.any
};
export { Checkbox };
export default withDefaultComponentProps(COMPONENT_NAME, {
    uncheckedIcon: /*#__PURE__*/ React.createElement(CheckboxSvg, null),
    checkedIcon: /*#__PURE__*/ React.createElement(CheckboxCheckedSvg, null),
    tabIndex: 0
}, Checkbox);
